// extracted by mini-css-extract-plugin
export default {"forgot-password":"forgotPassword_forgot-password__iPNFL"};